import { Box, Skeleton, Grid } from "@mui/material";

export default function TableSkeleton() {
  return (
    <Box mt={1}>
      <Skeleton variant="rounded" width={"100%"} height={30} animation="wave" />
      <Grid container mt={1} spacing={1}>
        <Grid item md={3}>
          <Skeleton
            variant="rounded"
            width={"100%"}
            height={20}
            animation="wave"
          />
        </Grid>
        <Grid item md={3}>
          <Skeleton
            variant="rounded"
            width={"100%"}
            height={20}
            animation="wave"
          />
        </Grid>
        <Grid item md={3}>
          <Skeleton
            variant="rounded"
            width={"100%"}
            height={20}
            animation="wave"
          />
        </Grid>
        <Grid item md={3}>
          <Skeleton
            variant="rounded"
            width={"100%"}
            height={20}
            animation="wave"
          />
        </Grid>
      </Grid>
      <Grid container mt={1} spacing={1}>
        <Grid item md={3}>
          <Skeleton
            variant="rounded"
            width={"100%"}
            height={20}
            animation="wave"
          />
        </Grid>
        <Grid item md={3}>
          <Skeleton
            variant="rounded"
            width={"100%"}
            height={20}
            animation="wave"
          />
        </Grid>
        <Grid item md={3}>
          <Skeleton
            variant="rounded"
            width={"100%"}
            height={20}
            animation="wave"
          />
        </Grid>
        <Grid item md={3}>
          <Skeleton
            variant="rounded"
            width={"100%"}
            height={20}
            animation="wave"
          />
        </Grid>
      </Grid>
      <Grid container mt={1} spacing={1}>
        <Grid item md={3}>
          <Skeleton
            variant="rounded"
            width={"100%"}
            height={20}
            animation="wave"
          />
        </Grid>
        <Grid item md={3}>
          <Skeleton
            variant="rounded"
            width={"100%"}
            height={20}
            animation="wave"
          />
        </Grid>
        <Grid item md={3}>
          <Skeleton
            variant="rounded"
            width={"100%"}
            height={20}
            animation="wave"
          />
        </Grid>
        <Grid item md={3}>
          <Skeleton
            variant="rounded"
            width={"100%"}
            height={20}
            animation="wave"
          />
        </Grid>
      </Grid>
      <Grid container mt={1} spacing={1}>
        <Grid item md={3}>
          <Skeleton
            variant="rounded"
            width={"100%"}
            height={20}
            animation="wave"
          />
        </Grid>
        <Grid item md={3}>
          <Skeleton
            variant="rounded"
            width={"100%"}
            height={20}
            animation="wave"
          />
        </Grid>
        <Grid item md={3}>
          <Skeleton
            variant="rounded"
            width={"100%"}
            height={20}
            animation="wave"
          />
        </Grid>
        <Grid item md={3}>
          <Skeleton
            variant="rounded"
            width={"100%"}
            height={20}
            animation="wave"
          />
        </Grid>
      </Grid>
    </Box>
  );
}
